import { render, staticRenderFns } from "./ControlAcceso.vue?vue&type=template&id=e996c55e"
import script from "./ControlAcceso.vue?vue&type=script&lang=js"
export * from "./ControlAcceso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports